/**
 * 常用旅客类
 */
export default class Contacts {
  constructor(contacts = {}) {
    this.id = contacts.contactsId
    Object.assign(this, contacts)
  }

  /**
   * 展示的证件号码的证件类型
   */
  get numberLabel() {
    let label = ''
    if (this.cardType) {
      label = this.cardName
    } else if (this.passport) {
      label = '护照'
    } else if (this.otherNumber) {
      label = this.cardName
    }
    return label
  }

  /**
   * 展示的证件号码
   */
  get numberStr() {
    return this.idNumber || this.passport || this.otherNumber || '无证件号码'
  }

}
